import React, { useEffect, useState } from "react";
import { auction_list_table_header as tableHeaders } from "../../constants/auctionListTableHeader";
import Main from "../main";
import Loader from "../Loader/Loader";
import styled from "styled-components";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import PrimaryButton from "../elements/button";
import { dateFormatDDMMYYYY } from "../../utils/dateFormatDDMMYYYY";
import { IoIosSearch } from "react-icons/io";


// Styled components
const StyledTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 20px;
`;

const StyledTh = styled.th`
	width: 150px;
	height: 50px;
	background-color: #f2f2f2;
	padding: 8px;
	text-align: left;
	border: 1px solid #dddddd;
	font-weight: 600;
	font-size: 14px;
`;

const StyledTd = styled.td`
	padding: 8px;
	border: 1px solid #dddddd;
	height: 50px;
	width: 100px;
`;

const PaginationWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;

const StyledPagination = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	border-color: #f2f2f2;
	border-radius: 4px;
	cursor: pointer;
	margin: 0 5px;
`;

const AuctionListTable = ({ loading, data, itemsPerPage, viewTractors }) => {
	const [filterdata, setFilterdata] = useState(data);
	const [currentPage, setCurrentPage] = useState(1);
	const totalPages = Math.ceil(filterdata?.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = currentPage * itemsPerPage;
	const currentData = filterdata?.slice(startIndex, endIndex);
	const [searchQuery, setSearchQuery] = useState("");
	//console.log("filterdata",filterdata,currentData,startIndex,endIndex);
	//console.log(startIndex,endIndex,currentData,totalPages,data.length)

	// if (currentData?.length < itemsPerPage) {
	// 	const length = itemsPerPage - currentData.length;
	// 	for (let i = 0; i <= length; i++) {
	// 		currentData.push({
	// 			name: "",
	// 			auction_group: "",
	// 			status: "",
	// 			start_date: "",
	// 			end_date: "",
	// 			created_at: -"",
	// 		});
	// 	}
	// }

	useEffect(() => {
		if (searchQuery !== "") {
			const filteredDataArray = data?.filter((item) => {
				if (
					toCheckIncludedSearchKeyInWords(item?.name, searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.auction_group, searchQuery) ||
					toCheckIncludedSearchKeyInWords(item?.status, searchQuery) ||
					toCheckIncludedSearchKeyInWords(
						dateFormatDDMMYYYY(item?.start_date),
						searchQuery
					) ||
					toCheckIncludedSearchKeyInWords(
						dateFormatDDMMYYYY(item?.end_date),
						searchQuery
					) ||
					toCheckIncludedSearchKeyInWords(
						dateFormatDDMMYYYY(item?.created_at),
						searchQuery
					)
				) {
					return item;
				}
				return false;
			});
			setFilterdata(filteredDataArray);
		}else{
			setFilterdata(data);
		}
		setCurrentPage(1);
	}, [searchQuery]);

	const handlePageChange = (page) => {
		if (page > 0 && page <= totalPages) {
			setCurrentPage(page);
		}
	};

	const toCheckIncludedSearchKeyInWords = (word, searchKey) => {
		return (word || "")
			.toString()
			.toLowerCase()
			.includes(searchKey.toLowerCase());
	};

	const handleChangeSearch = (e) => {
		const { value } = e.target;
		setSearchQuery(value);
	};

	const inputStyle = {
		width: '100%',
		padding: '10px',
		fontSize: '16px',
		boxSizing: 'border-box',
		transition: 'all 100ms ease 0s',
		backgroundColor: 'rgb(255, 255, 255)',
		borderWidth: 0,
		outline: '0px !important',
		opacity: 1
	
	} 

	return (
		<Main>
			<div
				style={{
					width: "100%",
					backgroundColor: "#FFFFFF",
					padding: "20px",
					borderRadius: "5px",
					maxWidth: "1080px",
				}}
			>
				{loading ? (
					<Loader />
				) : (
					<div
						style={{
							width: "100%",
							backgroundColor: "#FFFFFF",
							borderRadius: "5px",
						}}
					>
						<div style={{ width: "100%" }}>
							<PaginationWrapper>
								<div style={{display:'flex', alignItems:'center', padding: '0 5px' , borderRadius:'4px' ,borderStyle: 'solid', borderWidth: '1px' ,borderColor: 'rgb(204, 204, 204)',}}>
									<IoIosSearch style={{ width:'24px', height:'24px'}} />
									<input
										style={inputStyle}
										type="text"
										id="search"
										placeholder="Search..."
										onChange={handleChangeSearch}
										value={searchQuery}
									/>
								</div>
								<div style={{ display:'flex', alignItems:'center'}}>
								<div>
									<p>Total Records: {filterdata?.length}</p>
								</div>
								<div style={{ display: "flex" }}>
									<StyledPagination
										onClick={() => handlePageChange(currentPage - 1)}
										disabled={currentPage === 1}
									>
										<BiChevronLeft style={{ height: "30px", width: "30px" }} />
									</StyledPagination>
									<div style={{ display: "flex", alignItems: "center" }}>
										Page{" "}
										<StyledPagination style={{ padding: "3px" }} active>
											{currentPage}
										</StyledPagination>
										of {totalPages}
									</div>
									<StyledPagination
										onClick={() => handlePageChange(currentPage + 1)}
										disabled={currentPage === totalPages}
									>
										<BiChevronRight style={{ height: "30px", width: "30px" }} />
									</StyledPagination>
								</div>
								</div>
							</PaginationWrapper>
						</div>
						<div style={{ overflowX: "scroll" }}>
							<StyledTable>
								<thead>
									<tr>
										{tableHeaders?.map(
											(header, index) =>
												header?.visibility && (
													<StyledTh key={`${header.name}_${index}`}>
														{header.name}
													</StyledTh>
												)
										)}
									</tr>
								</thead>
								<tbody>
									{currentData?.map((item, index) => (
										<tr key={index}>
											<StyledTd>
												<PrimaryButton onClick={() => viewTractors(item)}>
													View Tractors
												</PrimaryButton>
											</StyledTd>
											<StyledTd>{item?.name}</StyledTd>
											<StyledTd>{item?.auction_group}</StyledTd>
											<StyledTd>{item?.status}</StyledTd>
											<StyledTd>
												{dateFormatDDMMYYYY(item?.start_date)}
											</StyledTd>
											<StyledTd>{dateFormatDDMMYYYY(item?.end_date)}</StyledTd>
											<StyledTd>
												{dateFormatDDMMYYYY(item?.created_at)}
											</StyledTd>
										</tr>
									))}
								</tbody>
							</StyledTable>
						</div>
					</div>
				)}
			</div>
		</Main>
	);
};

export default AuctionListTable;
